export default {
    url: '/login',
    params: {
        toState: 'authorized.home',
        toParams: {}
    },
    template: '<auth/>'
};



// WEBPACK FOOTER //
// ./src/app/states/unauthorized/login/index.js